const PENDING_TENANT_SCOPE_SYNC_KEY = 'lift-pending-tenant-scope-sync';

/**
 * Full page load into another tenant (username/password session).
 *
 * The cohort scope is not fetched before leaving: doing so updated the current
 * page with the new tenant's scope, which made it flicker. Instead the new page
 * refreshes it in the background (see useActiveTenantScopeSync); the scope is
 * only read when the user acts, not to render, so nothing waits on it.
 */
export function reloadIntoTenant(slug: string): void {
  try {
    sessionStorage.setItem(PENDING_TENANT_SCOPE_SYNC_KEY, '1');
  } catch {
    // Without storage the scope is refreshed on the next session check.
  }
  window.location.assign(`/${slug}/home`);
}

/** True once after reloadIntoTenant, so the new page refreshes its scope. */
export function consumePendingTenantScopeSync(): boolean {
  try {
    if (sessionStorage.getItem(PENDING_TENANT_SCOPE_SYNC_KEY) === null) {
      return false;
    }
    sessionStorage.removeItem(PENDING_TENANT_SCOPE_SYNC_KEY);
    return true;
  } catch {
    return false;
  }
}
